import { AreaGateReference } from './../../../gate-keeping.model';
import { Component, Inject, OnInit } from '@angular/core';
import { AppServerAPI, TabComponent } from '@sdbn/common';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-gate-keeper-control-select-gate-dialog',
  templateUrl: './gkc-select-gate-dialog.component.html',
  styleUrls: ['./gkc-select-gate-dialog.component.scss']
})
export class GKCSelectGateDialogComponent implements OnInit {

  direction: 'IN' | 'OUT';

  areaGates: Array<AreaGateReference>;
  allAreaGates: Array<AreaGateReference>;


  selectedAreaGate: AreaGateReference;

  constructor(
    public dialogRef: MatDialogRef<GKCSelectGateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI
  ) { }

  ngOnInit(): void {

    this.appServerAPI.execute<Array<AreaGateReference>>('/tmc-common/gate-keeper-app/getAllGates', null).subscribe(response => {
      let gates = new Array<AreaGateReference>();
      for (let entry of response) {
        gates.push(new AreaGateReference(entry));
      }
      this.allAreaGates = gates;
      this.areaGates = this.allAreaGates.filter(g => g.direction === 'BOTH' || g.direction === this.direction);
    });

  }

  public handleTabChange(tab: TabComponent) {
    this.direction = tab.data;
    if (this.areaGates != null) {
      this.areaGates = this.allAreaGates.filter(g => g.direction === 'BOTH' || g.direction === this.direction);
      console.log('tab changed', this.direction, this.areaGates);
    }
  }

  public close() {
    this.dialogRef.close(null);
  }

  public confirm() {
    let result = new AreaGateReference(this.selectedAreaGate);
    result.direction = this.direction;
    this.dialogRef.close(result);
  }

  public selectAreaGate(areaGate: AreaGateReference) {
    this.selectedAreaGate = areaGate;
  }
}
